import { Injectable, inject } from '@angular/core'
import { Filter, HttpParamsBuilder, RestClientPaged } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { Property } from './property'
import { ConstraintOperator } from '../process/capability-spec/constraints/constraint-operator'
import { JsonMap } from '../orders/work-orders/work-order'
import { Observable } from 'rxjs'

export class PropertyFilter {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public static readonly IDS_KEY = 'ids'

  public static readonly KINDS_KEY = 'kinds'

  /***************************************************************************
   *                                                                         *
   * Static Builders                                                         *
   *                                                                         *
   **************************************************************************/

  public static ids(propertyIds: string[] | string): Filter {
    return new Filter(this.IDS_KEY, propertyIds)
  }

  public static kinds(...kinds: string[]): Filter {
    return new Filter(this.KINDS_KEY, kinds)
  }
}

@Injectable({
  providedIn: 'root',
})
export class PropertyService extends RestClientPaged<Property, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private operatorCache: JsonMap<ConstraintOperator[]>

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/properties', http, {
      idField: 'id',
    })

    this.buildCache() // TODO refactor to use observables if other components support this
  }

  /***************************************************************************
   *                                                                         *
   * Operators API /operators                                                *
   *                                                                         *
   **************************************************************************/

  public getAvailableOperators(property: Property): ConstraintOperator[] {
    if (this.operatorCache) {
      return this.operatorCache[property.type]
    } else {
      this.log.error('Operator cache not built!')
      return []
    }
  }

  /***************************************************************************
   *                                                                         *
   * Resolver API /resolve                                                   *
   *                                                                         *
   **************************************************************************/

  // Info: Only supports Product Properties at the moment!
  public resolve(propertyIds: string[], workItemId: string): Observable<JsonMap<string>> {
    return this.http.get<JsonMap<string>>(this.restEndpoint + '/resolve', {
      params: HttpParamsBuilder.start()
        .appendFilter(PropertyFilter.ids(propertyIds))
        .append('workItemId', workItemId)
        .build(),
    })
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private buildCache(): void {
    this.http.get<JsonMap<ConstraintOperator[]>>(this.restEndpoint + '/operators').subscribe({
      next: (operators) => (this.operatorCache = operators),
      error: (err) => this.log.error('Could not build operator cache!', err),
    })
  }
}
